export default "__VITE_ASSET__BxTAGEri__"